import React from "react";

import "./index.scss";

export default function AxelCheckbox({ id, inlineStyle = {}, handler = () => {}, label, ...inputs }) {
    const { defaultChecked, checked} = inputs
    return (
    <div className="a-checkbox" style={inlineStyle}>
      <input
        type="checkbox"
        id={id}
        defaultChecked={defaultChecked}
        checked={checked}
        {...inputs}
        onChange={(e) => {
          handler(e.target.id, e.target.checked);
        }}
        maxLength={190}
      />
      <label htmlFor={id}>{label}</label>
    </div>
  );
}
